export default [
  {
    path: "/admin/currencies",
    name: "currencies",
    meta: { requiresAuth: true },
    component: () => import("@/pages/exchange-rate-v2/currency/index.vue")
  }
]
